const els = document.querySelectorAll('.js-FooterNav .footer-nav__title')

els.forEach(el => {
  el.addEventListener('click', function(e) {
    const parent = e.currentTarget.closest('.footer-nav__group')

    parent.classList.toggle('is-open')
  });
});
